import { StandaloneNodeLogger } from '@wix/standalone-node-bi-logger';
import type { BiEvent, BiLogger } from '@wix/wix-bi-logger-client';
import { readUserConfig } from '@wix/cli-user-config';
import { getTestOverrides } from '@wix/cli-test-overrides';
import { resolveUserFields } from './add-user-fields.js';

interface BiDefaultFields {
  [key: string]: string | number | undefined | null;
  aiAgentName?: string;
  cliEnvName?: string | null;
  cliTrackingId?: string | null;
  userId?: string;
}

export async function createBiLogger(
  defaultFields: BiDefaultFields = {}
): Promise<BiLogger> {
  const testBaseUrl = getTestOverrides().biLoggerBaseUrl;
  const options = testBaseUrl ? { baseUrl: testBaseUrl } : {};
  const { telemetry: isTelemetryOn } = await readUserConfig();

  return new StandaloneNodeLogger()
    .factory(options)
    .updateDefaults({
      localTime: () => Date.now(),
      ...defaultFieldsToBiEvent(defaultFields),
    })
    .setMuted(!isTelemetryOn)
    .logger();
}

function defaultFieldsToBiEvent(defaultFields: BiDefaultFields): BiEvent {
  const { cliEnvName, aiAgentName, userId, cliTrackingId, ...rest } =
    defaultFields;

  const result: BiEvent = {};
  for (const [key, value] of Object.entries(rest)) {
    if (value != null) {
      result[key] = value;
    }
  }

  if (cliEnvName) {
    result.environment = cliEnvName;
  }

  if (aiAgentName) {
    result.ai_agent_name = aiAgentName;
  }

  if (cliTrackingId) {
    result.tracking_id = cliTrackingId;
  }

  return { ...result, ...resolveUserFields(userId) };
}
